.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}
.col12 {
	grid-column: span 12;
}
.col6 {
	grid-column: span 6;
}
.col3 {
	grid-column: span 3;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: #374151;
	margin-bottom: 0;
}
.req {
	color: #ef4444;
	margin-left: 2px;
}

.inputWrapper {
	position: relative;
	width: 100%;
}

.input {
	width: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	padding: 0.5rem 2.5rem 0.5rem 0.65rem; /* espacio para el botón */
	font-size: 0.95rem;
	color: #111827;
	background: #fff;
	outline: none;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;
}
.input:focus {
	border-color: #c7d2fe;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.inputError {
	border-color: #ef4444;
}
.inputError:focus {
	border-color: #ef4444;
	box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.sm {
	padding: 0.4rem 2.2rem 0.4rem 0.6rem;
	font-size: 0.9rem;
}
.md {
	padding: 0.5rem 2.5rem 0.5rem 0.65rem;
	font-size: 0.95rem;
}
.lg {
	padding: 0.6rem 2.8rem 0.6rem 0.75rem;
	font-size: 1rem;
}

.showPasswordBtn {
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	z-index: 10;
	display: flex;
	align-items: center;
}

.helper {
	font-size: 0.8rem;
	color: #6b7280;
}
.error {
	font-size: 0.8rem;
	color: #b91c1c;
	margin-top: -5px;
}

@media (max-width: 640px) {
	.col6 {
		grid-column: span 12;
	}
}
